import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    AppBar,
    Box,
    Hidden,
    IconButton, makeStyles,
    Toolbar
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import InputIcon from '@material-ui/icons/Input';
import Logo from '../../components/Logo';
import {msalInstance} from "../../security/AuthProvider";

const useStyles = makeStyles(() => ({
    root: {},
    title: {
        paddingLeft: "16px",
        fontSize: "24px"
    }
}));

const TopBar = ({
	className,
	onMobileNavOpen,
	...rest
}) => {

        const classes = useStyles();

		const logout = async () => {
		   await msalInstance.logoutRedirect();
		}

		return (
            <AppBar
                elevation={0}
                {...rest}
            >
                <Toolbar>
                    <RouterLink to="dashboard">
                        <Logo />
                    </RouterLink>
                    <Box flexGrow={1}>
                        <span className={classes.title}>PE 2</span>
                    </Box>
                    <Hidden mdDown>
                        <IconButton color="inherit" onClick={logout}>
                            <InputIcon />
                        </IconButton>
                    </Hidden>
                    <Hidden lgUp>
                        <IconButton
                            color="inherit"
                            onClick={onMobileNavOpen}>
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                </Toolbar>
            </AppBar>
		);
};

TopBar.propTypes = {
	className: PropTypes.string,
	onMobileNavOpen: PropTypes.func
};

export default TopBar;